import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
	selector: 'button-export',
	templateUrl: './button-export.component.html',
	styleUrls: ['./button-export.component.scss'],
})
export class ButtonExportComponent implements OnInit {
	@Output() eventClick = new EventEmitter<any>();

	constructor() {
		//This is intentional.
	}

	ngOnInit(): void {
		//This is intentional.
	}

	export() {
		this.eventClick.emit();
	}
}
